import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-clifton-park-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-clifton-park-ny", statusCode: 301 });
  },
});
